import { Component } from "react";
import auth from "./Authenticate";
import LoginPageBackground from "../assets/images/backgrounds/bg_loginpage.jpg";
import { Button } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSkullCrossbones } from "@fortawesome/free-solid-svg-icons";
import errorBoundaryService from "../Services/ErrorBoundaryService";

class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, errorData) {
		console.log(error);
		errorBoundaryService.log(errorData);
	}

	render() {
		const handleRefresh = () => {
			window.location.reload();
		};

		const handleReturnToHome = () => {
			window.location.href = window.location.origin;
		};

		const handleLogout = () => {
			auth.logout();
			window.location.reload();
		};

		if (this.state.hasError) {
			return (
				<div
					style={{
						height: "100vh",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						backgroundImage: `url(${LoginPageBackground})`,
						backgroundRepeat: "no-repeat",
						backgroundSize: "cover",
						backgroundPosition: "center",
						flexDirection: "column",
					}}
				>
					<div
						style={{
							display: "flex",
							background: "#ffffff80",
							backdropFilter: "8px",
							padding: "30px",
							borderRadius: "1em",
							flexDirection: "column",
						}}
					>
						<h1>
							Wystąpił nieznany błąd krytyczny <FontAwesomeIcon aria-label={"fa-skull"} icon={faSkullCrossbones} />
						</h1>
						<Button variant="outlined" onClick={handleLogout}>
							Wyloguj się
						</Button>
						<Button variant="outlined" onClick={handleRefresh}>
							Odśwież ten moduł
						</Button>
						<Button variant="outlined" onClick={handleReturnToHome}>
							Powrót do strony głównej
						</Button>
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
